import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { ProductGridCard, VariantGroupingCard } from '../cards';

export const DEFAULT_PRODUCT_GRID_CONFIG = {
    productGrid: {
        maxColumns: 4,
        paginationPosition: 'below',
        showTotalProducts: true,
        // FUTURE: visible outlined/elevated card around each product in the
        // grid. Not yet supported by the storefront renderer; once it is,
        // surface this as a toggle in the ProductGridCard. Kept here so the
        // preview mockup (and any wiring downstream) can pick it up later
        // without a schema migration.
        showCardOutline: false,
    },
    variantGrouping: {
        groupAsOne: true,
        showSwatches: true,
        maxVariants: 4,
    },
};

/**
 * Body of the Product grid config modal — composes the two grid-related
 * cards. Opened from the cog that sits between cards 2 and 3 of the
 * Verkenner mockup. Pure content; the parent owns the Dialog wrapper.
 */
const ProductGridModal = ({
    value = DEFAULT_PRODUCT_GRID_CONFIG,
    onChange,
    theme,
    t,
}) => {
    const cardOnChange = (section) => (field, val) => {
        if (!onChange) return;
        onChange({
            ...value,
            [section]: { ...(value?.[section] || {}), [field]: val },
        });
    };

    return (
        <Stack spacing={2}>
            <ProductGridCard
                value={value.productGrid}
                onChange={cardOnChange('productGrid')}
                theme={theme}
                t={t}
            />
            <VariantGroupingCard
                value={value.variantGrouping}
                onChange={cardOnChange('variantGrouping')}
                theme={theme}
                t={t}
            />
        </Stack>
    );
};

ProductGridModal.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default ProductGridModal;
